import React from 'react';
import { Link } from 'react-router-dom';

const TechnicianNavbar = () => (
  <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur">
    <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.35em] text-slate-500">
          Puerto Rico Windows & Doors
        </p>
        <p className="text-lg font-bold text-slate-900">Panel de Instalaciones</p>
      </div>
      <Link
        to="/warehouse"
        className="rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
      >
        Ir a almacén
      </Link>
    </div>
  </header>
);

export default TechnicianNavbar;
